export default __webpack_public_path__ + "static/media/returnDrug.f3478c9a.svg";